import { Extension } from '@tiptap/core';

const TabToSpaces = Extension.create({
    name: 'tabToSpaces',

    addKeyboardShortcuts() {
        return {
            Tab: () => {
                const { editor } = this;
                const { selection } = editor.state;
                const { from, to } = selection;
                const { tr } = editor.state;

                if (from === to) {
                    tr.insertText('    ', from);
                } else {
                    tr.insertText('    ', from, to);
                }

                editor.view.dispatch(tr);

                return true;
            },
        };
    },
});

export default TabToSpaces;
